const softwares = ['Kahoot', 'Alexia', 'Additio', 'iDoceo', 'Classdojo', 'Socrative', 'Educa360', 'Geogebra']

export default softwares